import { Col, Label, Row } from '@gower/react-ui/components';
import { DataGrid, DataGridColumn } from '@gower/react-ui/template/data-grid';
import React from 'react';
import { useStore } from '../../store';

export const HistoryTab: React.FC = () => {

    const store = useStore();
    const history = store.AuthorizationHistory;

    return <>
        <Row columns paddingY={10}>
            <Col padding={15}>
                <Label xxsmall bold label="Historial de estado" />
            </Col>
            <Col minHeight={300}>
                <DataGrid
                    showReload
                    data={history}
                    scroll
                    loading={store.Status.isLoading}
                    reloadFn={() => store.reloadHistory()}
                >
                    <DataGridColumn title="Fecha" field="date" size={100}
                        template={( { data } ) => (
                            <Label p >
                                {data.Date?.format( 'DD/MM/YYYY HH:mm:ss' )}
                            </Label>
                        )}
                    />
                    <DataGridColumn title="Estado" field="Status.Description" />
                    <DataGridColumn title="Detalle" field="StatusDetail.Description" />
                    <DataGridColumn title="" field="Message" />
                </DataGrid>
            </Col>
        </Row>
    </>;

};